import { ValidatorResponse } from '../../Interface/Response/ValidatorResponse';

export const filterResults = (response: ValidatorResponse): ValidatorResponse => {
    if (response.results.length === 0) {
        return response;
    }

    return {
        ...response,
        results: [
            {
                ...response.results[0],
                beoordeling: {
                    ...response.results[0].beoordeling,
                    beoordelingResponse: {
                        ...response.results[0].beoordeling.beoordelingResponse,
                        regel: response.results[0].beoordeling.beoordelingResponse.regel.filter(
                            regel => regel.resultaat !== null && regel.resultaat !== undefined,
                        ),
                    },
                },
            },
        ],
    };
};
